import { generateUseContext } from '@guiker/react-context'

import { ClaimsAuthenticationContext } from './ClaimsAuthenticationContext'

export const useClaimsAuthenticationContext = generateUseContext(ClaimsAuthenticationContext)
